import { SPAYEE_BASE_API } from "@/shared/constants/env/internalService.constants";
import { QUERY_PARAMS } from "@/shared/constants/storage.constants";
import { CreatorSignupType, SignUpOTPType } from "@/shared/types/signup.types";
import { getFromLocal } from "@/shared/utils/storage.util";
import { SIGNUP_TYPE } from "@shared-types/enums/signup";
import axios from "axios";
import { parseCookies } from "nookies";

export const api = {
  feature: {
    signup: {
      emailSignup: (params: CreatorSignupType): Promise<{ data: any }> => {
        const {
          email,
          phone,
          countryCode,
          name,
          recaptchaToken,
          password,
          _fprom_code,
          _fprom_track,
          skipOnboarding,
          destination,
          gclid,
          orgCountryCode,
          appsumoCode,
        } = params;

        let url = `${SPAYEE_BASE_API}/t/api/creator/public/courseplatform/signup/v2`;

        const utmFields = getFromLocal("utmFields");

        const requestBody = {
          signup_type: (params as any).signupType || SIGNUP_TYPE.NORMAL,
          token: recaptchaToken,
          email,
          phone,
          name,
          password,
          gref: getFromLocal("gref"),
        } as any;

        if (utmFields) {
          requestBody.utmFields = JSON.stringify(utmFields);
        }
        const cookies = parseCookies();
        const queryParams = getFromLocal(QUERY_PARAMS);
        if (queryParams && typeof queryParams === "object") {
          if (queryParams.gclid) {
            requestBody.gclid = queryParams.gclid;
          }
          if (queryParams.matchtype) {
            requestBody.matchtype = queryParams.matchtype;
          }
          if (queryParams.device) {
            requestBody.device = queryParams.device;
          }
        }

        if (!_fprom_code && cookies._fprom_code) {
          requestBody._fprom_code = cookies._fprom_code;
        } else if (_fprom_code) {
          requestBody._fprom_code = _fprom_code;
        }
        if (!_fprom_track && cookies._fprom_track) {
          requestBody._fprom_track = cookies._fprom_track;
        } else if (_fprom_track) {
          requestBody._fprom_track = _fprom_track;
        }
        if (countryCode) {
          requestBody.countryCode = countryCode;
        }
        if (orgCountryCode) {
          requestBody.orgCountryCode = orgCountryCode;
        }
        if (params.hasOwnProperty("destination")) {
          requestBody.destination = destination;
        }
        if (appsumoCode) {
          requestBody.appsumoCode = appsumoCode;
        }

        if ((params as any).googleAuthCode) {
          requestBody.googleAuthCode = (params as any).googleAuthCode;
        }
        return axios.post(url, requestBody);
      },
      otpVerify: (params: SignUpOTPType): Promise<{ data: any }> => {
        const { email, phone, type, token, name, source } = params;

        let url = `${SPAYEE_BASE_API}/s/admin/account/otp/send?email=${email}&phone=${phone}&type=${type}&token=${token}&name=${name}`;
        
        if (source) {
          url += `&source=${source}`;
        }

        return axios.get(url);
      },
    },
  },
};
